import Card from '@spotnana/pixel-react/dist/Card';
import { Flex } from '@spotnana/pixel-react/dist/Box';
import ShimmerBox from '@spotnana/pixel-react/dist/Shimmer';
import { AirCheckoutFareNodeTypeEnum, IAirCheckoutFareBreakupNode } from 'obt-common';

interface IFareBreakupLoadingProps {
  breakupData?: IAirCheckoutFareBreakupNode[];
}
const FareBreakupLoading = ({ breakupData }: IFareBreakupLoadingProps): JSX.Element => {
  if (!breakupData) {
    return (
      <Card
        my={0}
        pb={20}
        bg="bg.regular"
        border="none"
        borderRadius="lg"
        boxShadow="none"
        data-testid="fare-breakup-loading"
      >
        <Flex width="100%" alignItems="center" justifyContent="space-between">
          <Flex flex={1} flexDirection="column">
            <ShimmerBox my="8px" width="70px" height="16px" />
            <ShimmerBox my="8px" width="140px" height="14px" />
            <ShimmerBox my="8px" width="140px" height="14px" />
          </Flex>
          <Flex flex={1} flexDirection="column" alignItems="end">
            <ShimmerBox my="8px" width="140px" height="16px" />
            <ShimmerBox my="8px" width="140px" height="14px" />
            <ShimmerBox my="8px" width="140px" height="14px" />
          </Flex>
        </Flex>

        <Flex justifyContent="space-between" alignItems="center">
          <ShimmerBox mt="24px" width="100px" height="24px" />
          <ShimmerBox mt="24px" width="100px" height="24px" />
        </Flex>
      </Card>
    );
  }

  return (
    <Card
      my={0}
      pb={20}
      bg="bg.regular"
      border="none"
      borderRadius="lg"
      boxShadow="none"
      data-testid="fare-breakup-loading"
    >
      {breakupData.map((fareComponent) => {
        const { type } = fareComponent;

        if (type === AirCheckoutFareNodeTypeEnum.DIVIDER) {
          return <ShimmerBox mt="6px" mb="6px" width="100%" height="1px" />;
        }

        switch (type) {
          case AirCheckoutFareNodeTypeEnum.HEADING:
            return (
              <Flex justifyContent="space-between" alignItems="center">
                <ShimmerBox mt="8px" mb="10px" width="150px" height="20px" />
                <ShimmerBox mt="8px" mb="10px" width="100px" height="20px" />
              </Flex>
            );
          case AirCheckoutFareNodeTypeEnum.SUB_HEADING:
            return (
              <Flex justifyContent="space-between" alignItems="center">
                <ShimmerBox mt="10px" mb="8px" width="130px" height="16px" />
                <ShimmerBox mt="10px" mb="8px" width="80px" height="16px" />
              </Flex>
            );
          case AirCheckoutFareNodeTypeEnum.NORMAL:
            return (
              <Flex justifyContent="space-between" alignItems="center">
                <ShimmerBox mt="10px" mb="8px" width="100px" height="16px" />
                <ShimmerBox mt="10px" mb="8px" width="75px" height="16px" />
              </Flex>
            );
          case AirCheckoutFareNodeTypeEnum.ONLY_VALUE:
            return (
              <Flex justifyContent="end" alignItems="center">
                <ShimmerBox mt="10px" mb="8px" width="80px" height="20px" />
              </Flex>
            );
          case AirCheckoutFareNodeTypeEnum.INFO:
            return <ShimmerBox mt="10px" mb="8px" width="80px" height="20px" />;
          default:
            return null;
        }
      })}
    </Card>
  );
};

export default FareBreakupLoading;
